import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Image } from '@mantine/core'
import { useQueryClient } from '@tanstack/react-query'

import { AdvisorsListRoutePathsEnum } from '@/modules/advisorsPage/routes/advisorsListRouteConfig.types'

import { Button } from '@/components/Button/Button'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import { useAdvisorServiceAdvisorControllerGetAllAdvisorsKey } from '@/__generated__/queries'

import classes from './AdvisorWidget.module.css'

export function AdvisorWidget() {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()

  const handleAdvisorWidgetClick = () => {
    if (location.pathname === AdvisorsListRoutePathsEnum.ADVISORS_LIST) {
      queryClient.invalidateQueries({
        queryKey: [useAdvisorServiceAdvisorControllerGetAllAdvisorsKey],
      })
    }

    navigate(AdvisorsListRoutePathsEnum.ADVISORS_LIST)
  }

  return (
    <Box className={classes.widget}>
      <Image
        alt="Speak with a planner"
        h={48}
        mx="auto"
        src="/advisor_placeholder.png"
        w={48}
      />

      <Title className={classes.title} variant="h5">
        Speak with a planner
      </Title>

      <Text className={classes.text} variant="body_2">
        Have questions? Ask your planner anything related to your finances, at
        no charge to you!
      </Text>

      <Button
        miw="100%"
        mt={16}
        onClick={handleAdvisorWidgetClick}
        variant="primary"
      >
        Get Started
      </Button>
    </Box>
  )
}
